<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索登錄賬號|名稱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<el-button class="mr-2" v-auth="'add'+auth_val" @click="openModel(false)" type="primary" size="mini">添加學校</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button>

				</template>
				
				<!-- 高級搜索 -->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="賬號名稱" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索賬號名稱"></el-input>
						</el-form-item>

						<el-form-item label="登錄賬號" class="mb-0">
							<el-input size="small" v-model="from.username" placeholder="搜索登錄賬號"></el-input>
						</el-form-item>
						
						<el-form-item label="學校名稱" class="mb-0">
							<el-input size="small" v-model="from.school_name" placeholder="搜索學校名稱"></el-input>
						</el-form-item>

						<el-form-item label="學校地區" class="mb-0">
							<el-input size="small" v-model="from.school_address" placeholder="搜索學校地區"></el-input>
						</el-form-item>
						
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>
				
					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center"></el-table-column>

                <!-- <el-table-column align="center" prop="head" label="頭像">
					<template slot-scope="scope">
						<el-image 
						    style="width: 40px; height: 40px"
						    :src="scope.row.head" 
						    :preview-src-list="check_img_list">
						  </el-image>
					</template>
				</el-table-column> -->
				
				<el-table-column align="center" prop="name" label="用戶名稱">
				</el-table-column>

                <el-table-column align="center" prop="username" label="登錄賬號">
				</el-table-column>
				
				<el-table-column align="center" prop="pass" label="密碼">
				</el-table-column>
				
				<el-table-column align="center" prop="address" label="學校地區">
				</el-table-column>
				<el-table-column align="center" prop="school_name" label="學校名稱">
				</el-table-column>
				
                
				<el-table-column align="center" prop="status" label="登錄狀態" >
					<template slot-scope="scope">
						<el-button
						:type="scope.row.status ? 'success' : 'danger'" 
						size="mini"
						
						@click="changeUserStatus(scope.row)"
						plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
				
				<el-table-column prop="id" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope)">操作</el-button>
							<el-button @click="deleteItem(scope.row)"  v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  :title="editIndex > -1 ? '修改學校' : '添加學校'" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'120px'">
				
				
				<el-form-item label="用戶名稱" prop="name">
					<el-input v-model="form.name" placeholder="用戶名稱" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="登錄賬號" prop="username">
					<el-input v-model="form.username" :maxlength="16" :minlength="6" placeholder="登錄賬號" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>

				<el-form-item v-if="editIndex > -1 " label="原密碼" prop="pass">
					<el-input v-model="form.pass" disabled placeholder="原密碼" size="small" auto-complete="new-password"
					 style="width: 85%;"></el-input>
				</el-form-item>

                <el-form-item label="登錄密碼" prop="password">
					<el-input v-model="form.password" :maxlength="16" :minlength="6" show-password placeholder="登錄密碼" size="small" auto-complete="new-password"
					 style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item label="確認密碼" prop="password2">
					<el-input v-model="form.password2" :maxlength="16" :minlength="6" show-password placeholder="確認密碼" size="small"
					 style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="選擇學校" prop="school_id">
					<el-input v-if="editIndex>0" v-model="form.str_school" :maxlength="16" :minlength="6" disabled clearable size="small"
					 style="width: 85%;"></el-input>
					<el-select
						v-else
						size="small" style="width: 85%;"
						v-model="form.school_id"
						filterable
						remote
						reserve-keyword
						placeholder="請輸入關鍵詞:學校編號 - 學校地區 - 學校名稱"
						:remote-method="remoteMethodSchool"
						:loading="loading">
						<el-option
						v-for="item in schoolOptions"
						:key="item.id"
						:label="item.str_name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

					

                
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

		<!-- 用戶禁用彈窗 -->
		<el-dialog
			title="禁用用戶"
			:visible.sync="statusDialog.visible"
			width="500px"
			:close-on-click-modal="false"
			@close="closeStatusDialog"
		>
			<el-form :model="statusForm" :rules="statusRules" ref="statusForm" label-width="100px">
				<el-form-item label="用戶資訊">
					<div class="user-info">
						<p><strong>用戶ID:</strong> {{ statusForm.user_id }}</p>
						<p><strong>用戶名:</strong> {{ statusForm.name }}</p>
						<p><strong>當前狀態:</strong> 
							<el-tag :type="statusForm.current_status ? 'success' : 'danger'">
								{{ statusForm.current_status ? '啟用' : '禁用' }}
							</el-tag>
						</p>
					</div>
				</el-form-item>
				
				<el-form-item 
					label="禁用原因" 
					prop="reason" 
					:rules="[{ required: true, message: '禁用用戶時必須提供原因', trigger: 'blur' }]"
				>
					<el-input
						v-model="statusForm.reason"
						type="textarea"
						:rows="4"
						placeholder="請輸入禁用用戶的原因..."
						maxlength="500"
						show-word-limit
					></el-input>
				</el-form-item>
			</el-form>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeStatusDialog">取消</el-button>
				<el-button type="primary" @click="confirmStatusChange" :loading="statusDialog.loading">
					禁用
				</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import { mapState } from 'vuex';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					username: '',
					type:-1,
					address_id: -1,
					school_address: '',
					school_name: '',
					rule_id:'',
					time:[],
				},
				auth_val: 'SchoolAccount',
				preUrl: "data/schoolAccount", //列表地址
				delAllUrl: "data/delSchoolAccountAll", //批量删除地址
				delUrl: "data/delSchoolAccount", //删除單条地址
				addUrl: "data/addSchoolAccount", //添加/修改地址
				editStatusUrl:"data/editStatusSchoolAccount",//修改狀態地址

				tableData: [],
				schoolOptions: [],
				form: {
					id:0,
					name: "",
					username: '',
					
					password:'',
					password2:'',
					icon:'',
					school_id: null
				},
				rules: {
					name: [{
							required: true,
							message: "學校名稱不能為空",
							trigger: 'blur',
						},
					],
                    username: [{
							required: true,
							message: "登入帳號不能為空",
							trigger: 'blur',
						},
						{
							min: 6,
							max: 16,
							message: '名稱長度在 6 到 16 個字符',
							trigger: 'blur'
						}
					],
                    // icon: [{
					// 		required: true,
					// 		message: "請上傳頭像",
					// 		trigger: 'blur',
					// 	},
					
					// ],
                    password:[
						{
							min: 6,
							max: 16,
							message: '密碼長度在 6 到 16 個字符',
							trigger: 'blur'
						}
					],
					school_id: [{
							required: true,
							message: "請選擇學校",
							trigger: 'blur',
						},
					],
				},
				rule_list: [],
				school_list:[],
				check_img_list:[],

				prop: 'id',
				sort: 'descending',
				
				// 用戶狀態修改彈窗
				statusDialog: {
					visible: false,
					loading: false
				},
				statusForm: {
					user_id: 0,
					name: '',
					current_status: 1,
					reason: ''
				},
				statusRules: {
					reason: [
						{ required: true, message: '禁用用戶時必須提供原因', trigger: 'blur' }
					]
				},
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			// this.commonList(['school_list']);
		},
		methods: {
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: '兩次輸入密碼不一致',
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			remoteMethodSchool(query){
				if (query !== '') {
					this.loading = true;
					this.axios.post('/admin/data/getSchoolList', {
						value: query,
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						this.schoolOptions = all.data;
						this.loading = false;
					}).catch(err => {
						// 失敗
						this.schoolOptions = [];
						this.loading = false;
					})
				} else {
					this.schoolOptions = [];
					this.loading = false;
				}
			},
			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
                        name: "",
                        username: '',
                        password:'',
                        password2:'',
                        icon:'',
                        school_id: null
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.row.id,
						name: e.row.name,
						pass:e.row.pass,
						username: e.row.username,
						str_school: e.row.str_school,
						password: '',
						password2:e.row.password2,
						icon: e.row.icon,
						school_id:e.row.school_id,
					}
				
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					this.school_list = all.data.list.school

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 2;
				console.log(file.type)
				if (!isJPG) {
				  this.$message.error('文件格式错误!');
				}
				if (!isLt2M) {
				  this.$message.error('上傳图片大小不能超過 2MB!');
				}
				return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					rule_id:'',
					school_address: '',
					school_name: '',
					time:[],
					end_time:'',
					address_id:-1,
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
				}, 1)
			},
			
			// 用戶狀態修改
			changeUserStatus(row) {
				const newStatus = row.status === 1 ? 0 : 1;
				
				// 如果是啟用操作，直接調用API
				if (newStatus === 1) {
					this.directEnableUser(row);
					return;
				}
				
				// 如果是禁用操作，顯示彈窗
				this.statusForm = {
					user_id: row.id,
					name: row.name,
					current_status: row.status,
					reason: ''
				};
				this.statusDialog = {
					visible: true,
					loading: false
				};
				
				// 清空表單驗證
				this.$nextTick(() => {
					if (this.$refs.statusForm) {
						this.$refs.statusForm.clearValidate();
					}
				});
			},
			
			// 直接啟用用戶
			directEnableUser(row) {
				this.$confirm('確認啟用該用戶嗎？', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'info'
				}).then(() => {
					this.axios.post('/school/data/editStatusSchoolAccount', {
						id: row.id,
						status: 1,
						reason: ''
					}, {
						token: true
					}).then(res => {
						if (res.data.code === 1) {
							// 更新本地數據
							row.status = 1;
							this.$message({
								message: '啟用成功',
								type: 'success'
							});
							// 刷新列表
							this.getList();
						} else {
							this.$message.error(res.data.msg || '操作失敗');
						}
					}).catch(err => {
						this.$message.error('操作失敗，請稍後重試');
					});
				}).catch(() => {
					// 用戶取消操作
				});
			},
			
			// 關閉狀態彈窗
			closeStatusDialog() {
				this.statusDialog.visible = false;
				this.statusForm = {
					user_id: 0,
					name: '',
					current_status: 1,
					reason: ''
				};
			},
			
			// 確認狀態修改
			confirmStatusChange() {
				this.$refs.statusForm.validate((valid) => {
					if (valid) {
						this.statusDialog.loading = true;
						
						// 調用API修改狀態
						this.axios.post('/school/data/editStatusSchoolAccount', {
							id: this.statusForm.user_id,
							status: 0,
							reason: this.statusForm.reason
						}, {
							token: true
						}).then(res => {
							if (res.data.code === 1) {
								// 更新本地數據
								const user = this.tableData.find(item => item.id === this.statusForm.user_id);
								if (user) {
									user.status = 0;
								}
								
								this.$message({
									message: '禁用成功',
									type: 'success'
								});
								
								// 刷新列表
								this.getList();
							} else {
								this.$message.error(res.data.msg || '操作失敗');
							}
							this.closeStatusDialog();
						}).catch(err => {
							this.$message.error('操作失敗，請稍後重試');
							this.closeStatusDialog();
						}).finally(() => {
							this.statusDialog.loading = false;
						});
					}
				});
			}
		}
	}
</script>

<style>
.user-info {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.user-info p {
  margin: 5px 0;
  color: #606266;
}

.dialog-footer {
  text-align: right;
}
</style>
